<template>
  <div class="bg-white">
    <el-row>
      <el-col :span="24" :sm="{ offset: 8, span: 8 }">
        <highcharts ref="chart" :options="chartOptions"></highcharts>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "SupervisorChart",
  data: () => ({
    pieChart: {
      chart: {
        type: "pie",
        options3d: {
          enabled: true,
          alpha: 45,
          beta: 0
        }
      },
      title: false,
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: "pointer",
          depth: 35,
          dataLabels: {
            enabled: true,
            format: "{point.name}"
          }
        }
      },
      series: [
        {
          type: "pie",
          data: [
            { name: "Awaiting Delivery", y: 0, color: "#67c23a" },
            { name: "Pending", y: 0, color: "#909399" }
          ]
        }
      ]
    }
  }),
  computed: {
    user() {
      return this.$store.getters["auth/user"];
    },
    cardData() {
      return this.$store.getters["dashboard/cardData"];
    },
    chartOptions() {
      let pending = this.cardData.find(o => o.status_category == 1);
      let del = this.cardData.find(o => o.status_category == 2);

      let opt = this.pieChart;

      opt.series[0].data = [
        {
          name: "Awaiting Delivery",
          y: del ? del.count : 0,
          color: "#909399"
        },
        {
          name: "Pending",
          y: pending ? pending.count : 0,
          color: "#67c23a"
        }
      ];

      return opt;
    }
  },
  mounted() {
    this.$refs.chart.chart.reflow();
    console.log(this.$store.getters["auth/user"].user_type)
    if (this.$store.getters["auth/user"].user_type == 7) this.$router.push("/pending");
  }
};
</script>

<style lang="scss" scoped></style>
